<template>
    <div>
        <component :is="layout">
            <router-view/>
        </component>
        <snack-bar/>
    </div>
</template>

<script setup>
import {computed} from 'vue'
import {useRoute} from 'vue-router'
import Auth from '@/layouts/Auth.vue'
import Guest from '@/layouts/Guest.vue'
import Public from '@/layouts/Public.vue'
import {useNavigation} from "@/composables/globals";
import {useAuthStore} from "@/stores/authStore";
import {useAppTheme} from "@/composables/useAppTheme";

const $route = useRoute()
const authStore = useAuthStore();
const {navigateTo} = useNavigation();

// Apply the saved light/dark preference at app start.
useAppTheme().init();

const layout = computed(() => {
    // Public pages (share links) render for anyone with no auth/chrome/redirect.
    if ($route.meta.layout === 'public') {
        return Public;
    }
    if ((!authStore.isAuthenticated() && $route.meta.layout === 'auth')) {
        return navigateTo('login');
    } else if (authStore.isAuthenticated() && $route.meta.layout !== 'guest') {
        return Auth;
    } else {
        return Guest;
    }
})
</script>

<style>
#app {
    font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}
</style>
